import { TCustomControl } from 'mui-rte';
import RichTextIconComponent from './RichTextIconComponent';

const AlignLeftBlock = (props: { children?: React.ReactNode }) => {
  return (
    <div
      style={{
        textAlign: 'left'
      }}
    >
      {props.children}
    </div>
  );
};

const AlignCenterBlock = (props: { children?: React.ReactNode }) => {
  return (
    <div
      style={{
        textAlign: 'center'
      }}
    >
      {props.children}
    </div>
  );
};

const AlignRightBlock = (props: { children?: React.ReactNode }) => {
  return (
    <div
      style={{
        textAlign: 'right'
      }}
    >
      {props.children}
    </div>
  );
};

const customControlList: TCustomControl[] = [
  {
    name: 'alignLeft',
    component: RichTextIconComponent,
    type: 'block',
    blockWrapper: <AlignLeftBlock />
  },
  {
    name: 'alignCenter',
    component: RichTextIconComponent,
    type: 'block',
    blockWrapper: <AlignCenterBlock />
  },
  {
    name: 'alignRight',
    component: RichTextIconComponent,
    type: 'block',
    blockWrapper: <AlignRightBlock />
  }
];

export default customControlList;
